import { apiUrl } from "../config/api";

export async function submitEnquiry(enquiry) {
  const response = await fetch(apiUrl("/api/enquiries"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(enquiry),
  });
  const responseText = await response.text();
  let data;
  try {
    data = JSON.parse(responseText);
  } catch {
    throw new Error("Enquiry server returned an invalid response. Please make sure the API server is running.");
  }
  if (!response.ok || data.error) throw new Error(data.error || "Unable to submit enquiry.");
  return data.enquiry;
}
